module.exports = __webpack_public_path__ + "20250828d091945t/img/production-pic.2a7c54ea.png";